import { Component, Input, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MEDIA_ALISES } from '~shared/constants/media.constant';
import { CategoryCard, PAGE_TYPES } from '../../models';
import { ApplicationEventService } from '~shared/modules/application-event/services';
import { CategoryCardClickApplicationEvent } from '~shared/modules/application-event/models';
import { environment } from '~env/environment';
import { APP_CATEGORY_ROUTE, APP_LANDING_PAGE_ROUTE } from '~shared/constants';
import { NavigationHelper } from '~shared/services/navigation-helper.service';
import { PageDetectionUtil } from '~shared/utils/page-detection.util';

@Component({
  selector: 'app-content-card-list',
  templateUrl: './category-grid.component.html',
  styleUrls: ['./category-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoryGridComponent implements OnInit, OnDestroy {
  @Input() title: string;
  @Input() cards: Array<CategoryCard>;

  readonly NOT_EXPANDED_LIMIT = 4;
  readonly marketplaceLink = environment.appBaseUrl();
  isMobile = true;
  isExpanded = false;
  sbFormatParam = '/m/';
  currentUrl = this.navigationHelper.getCurrentUrl();

  private unsubscribe$ = new Subject<void>();

  get limit(): number {
    return this.isExpanded || !this.isMobile ? this.cards.length : this.NOT_EXPANDED_LIMIT;
  }

  get isContentLandingPage(): boolean {
    return PageDetectionUtil.isLandingPagePage(this.currentUrl);
  }

  constructor(
    private mediaObserver: MediaObserver,
    private cd: ChangeDetectorRef,
    private applicationEventService: ApplicationEventService,
    private navigationHelper: NavigationHelper
  ) {}

  ngOnInit(): void {
    this.initMediaObserver();
  }

  private initMediaObserver(): void {
    this.mediaObserver
      .asObservable()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.isMobile = this.mediaObserver.isActive(MEDIA_ALISES.mobile);
        this.cd.markForCheck();
      });
  }

  toggleExpanded(): void {
    this.isExpanded = !this.isExpanded;
    this.cd.markForCheck();
  }

  goTo(slug: string, pageType: string = 'categories'): void {
    const basePath = PAGE_TYPES[pageType] === 'landing-pages' ? APP_LANDING_PAGE_ROUTE : APP_CATEGORY_ROUTE;
    window.location.href = `${this.marketplaceLink}/${basePath}/${slug}`;
  }

  fireGAEvent(slug: string): void {
    this.applicationEventService.publish(new CategoryCardClickApplicationEvent({ label: slug }));
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
